import React, { useEffect, useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate, useParams } from "react-router-dom";
import { OfferDetails } from "../../types/General";
import { useLazyGetDiscountDetailsQuery } from "../../service/discount";
import { showError } from "../../constants/toasts";
import dayjs from "dayjs";
import Loader from "../../constants/Loader";
import CurrencyIcon from "../../components/dirham";

const ViewDiscount = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [discount, setDiscount] = useState<any | null>(null);

  const [getDiscountById, { isLoading }] = useLazyGetDiscountDetailsQuery();

  const getDiscountByIdApi = async () => {
    try {
      const response = await getDiscountById({
        id,
      }).unwrap();
      if (response.statusCode === 200) {
        const data: OfferDetails = response?.data;
        setDiscount(data);
  
          // Initialize images state
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };
  useEffect(() => {
    if (id) {
      getDiscountByIdApi();
    }
  }, [id]);

  return (
    <>
      <Loader isLoad={isLoading} />
      <div className="main_title">
        <h1>Discount & Coupon Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/discount-coupon")}>Discount & Coupon Management</button>- View Discount & Coupon Management
        </p>
      </div>

      <div className="cards">
        <div className="view_page">
          <div className="gap_p">
            <div className="w_33">
              <h6>Offer/Discount Name</h6>
              <p>{discount?.name || "-"}</p>
            </div>

            <div className="w_33">
              <h6>Coupon Code</h6>
              <p>
                <span className="status_btn c_success">
                  {discount?.code || "-"}
                </span>
              </p>
            </div>

            <div className="w_33">
              <h6>Discount Type</h6>
              <p>{discount?.discountType === 1 ? "Percentage" : "Flat"}</p>
            </div>

            <div className="w_33">
              <h6>Discount Value</h6>
              <p>
                {discount?.discount
                  ? discount?.discountType == 1
                    ? `${discount?.discount}%`
                    : <><CurrencyIcon width={12} height={12} style={{ verticalAlign: "baseline" }} />{discount?.discount}</>
                  : "-"}
              </p>
            </div>

            <div className="w_33">
              <h6>Valid From – To</h6>
              <p>
                {discount?.validFrom
                  ? dayjs(discount?.validFrom).format("DD MMMM YYYY")
                  : "-"}{" "}
                –{" "}
                {discount?.validTo
                  ? dayjs(discount?.validTo).format("DD MMMM YYYY")
                  : "-"}
              </p>
            </div>

            <div className="w_33">
              <h6>Created Date</h6>
              <p>
                {discount?.createdAt
                  ? dayjs(discount?.createdAt).format("DD MMMM YYYY")
                  : "-"}
              </p>
            </div>
            <div className="w_100">
              <h6>Applicable Services / Categories</h6>
              <ul className="inline_tags">
                {[
                  ...(discount?.services || []),
                  ...(discount?.categories || []),
                ].map((item: any, index: number) => (
                  <li key={index}>{item.name}</li>
                ))}
                {(!discount?.services?.length &&
                  !discount?.categories?.length) && <li>-</li>}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDiscount;
